import { WIDGET_NAMES } from '../../../constants/widgetNames';
import { ENTITY_TYPES } from '../../../constants/widgets';

export function recentToWidget({
  recentGameThemeId,
  recentGame,
  recentGameId,
  recentGameProviderId,
}) {
  return function mapper(widget) {
    switch (widget.name) {
      case WIDGET_NAMES.RECENT_THEMES: {
        if (!recentGameThemeId) return undefined;

        return {
          name: WIDGET_NAMES.GAMES,
          isRecent: true,
          config: {
            entityType: ENTITY_TYPES.THEME,
            entityId: recentGameThemeId,
            titleTemplate: widget.config.titleTemplate,
            description: '',
            excludeGameIds: [recentGameId],
          },
          orderId: widget.orderId,
        };
      }

      case WIDGET_NAMES.RECENT_PROVIDERS: {
        if (!recentGameProviderId) return undefined;

        return {
          name: WIDGET_NAMES.GAMES,
          isRecent: true,
          config: {
            entityType: ENTITY_TYPES.PROVIDER,
            entityId: recentGameProviderId,
            translationKey: recentGame?.providerTranslationKey ?? '',
            titleTemplate: widget.config.titleTemplate,
            description: '',
            excludeGameIds: [recentGameId],
          },
          orderId: widget.orderId,
        };
      }

      default:
        return widget;
    }
  };
}
